import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { fetchLinkViews } from '../store/resources';


export default function LinkReport() {
  const dispatch = useDispatch();
  const domain = useSelector(state => state.app.current_domain);
  const link_views = useSelector(state => state.linkViews);
  const {short_id} = useParams();

  useEffect(() => {
    if (domain && short_id) {
      dispatch(fetchLinkViews({domain, id: short_id}));
    }
  }, [dispatch, domain, short_id]);

  return (
    <div className="container px-0">
      <div className="row">
        <div className="col-12">
          <pre>{JSON.stringify(link_views, null, 2)}</pre>
        </div>
      </div>
    </div>
  );
}
